// extracted by mini-css-extract-plugin
export var centerText = "_6t-8";
export var container = "_6t-0";
export var doughnutContainer = "_6t-7";
export var legend = "_6t-a";
export var legendItemColorDisplay = "_6t-b";
export var legendItemLabel = "_6t-d";
export var legendItemValue = "_6t-c";
export var lg = "_6t-5";
export var maxWidth = "_6t-9";
export var md = "_6t-4";
export var responsive = "_6t-6";
export var sm = "_6t-3";
export var xs = "_6t-2";
export var xxs = "_6t-1";